import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import App from "./App";
import { store } from "../app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "../serviceWorker";
import config from "../utils/config";
import { datadogRum } from "@datadog/browser-rum";

import "@datadog/browser-logs/bundle/datadog-logs";
import { v4 as uuidv4 } from "uuid";

const sessionId = uuidv4();
window.DD_LOGS.init({
  clientToken: "pubfdc4cf8903cb67be1c15935456f4684b",
  site: "us5.datadoghq.com",
  service: "vesper-travel-portal",
  version: config.REACT_APP_VERSION,
  env: config.ENV.toLowerCase(),
  sessionSampleRate: 100,
  telemetrySampleRate: 100,
  forwardConsoleLogs: "all",
  trackInteractions: true,
  beforeSend: (log: any) => {
    log.browser_session_id = sessionId;
    log.path = window.location.pathname;
  },
});

datadogRum.init({
  applicationId: '0668121e-dabb-46c6-87c0-f09d3ede55e8',
  clientToken: 'pubfdc4cf8903cb67be1c15935456f4684b',
  site: "us5.datadoghq.com",
  service: "vesper-travel-portal",
  env: config.ENV.toLowerCase(),
  sessionSampleRate: config.ENV.toLowerCase() === "production" ? 70 : 100,
  sessionReplaySampleRate: config.SESSION_REPLAY_SAMPLE_RATE,
  version: config.REACT_APP_VERSION,
  trackUserInteractions: false,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask",
  allowedTracingUrls: [
    "https://vesper-qa.capitalone.com",
    "https://vesper-travel.capitalone.com",
  ],
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

serviceWorker.unregister();
